import { FC } from "react";
import { LayoutPropType } from "./type";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { Toaster } from "sonner";

const LayoutComponent: FC<LayoutPropType> = ({ children }) => {
  return (
    <>
      <Header />
      <Toaster position="top-right" richColors />
      {children}
      <Footer />
    </>
  );
};

export default LayoutComponent;
